import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { ProjectModifyPage } from './project-modify';
import { SellionsFormsModule } from '../../../../submodules/sellions_forms/projects/forms/src/public-api';

@NgModule({
  declarations: [ProjectModifyPage],
  imports: [SellionsFormsModule, IonicPageModule.forChild(ProjectModifyPage)],
})
export class ProjectModifyModule {}



// WEBPACK FOOTER //
// ./src/modules/projects/pages/project-modify/project-modify.module.ts